import Card_left from "../components/CardLeft";

export default function Kleskode() {
  return (
    <section>
      <Card_left >
        <div className="card-left-content">
          <div className="card-left-title">
            Kleskode
          </div>
          <p>
            Vi ønsker gjerne at gjestene våre kommer i kjole eller dress. De som velger å ha på kjole kan gjerne ha på en fin sommerkjole og de med dress kan ha på den dressen de har, men gjerne pynt med sommerlig tørkle eller slips. <br/><br/>

            Vi ønsker ikke at noen har på noe hvitt, eller noe som kan se hvitt ut, og heller ingen svarte eller veldig mørke kjoler. Vi ønsker heller ikke at noen har på bunad, med tanke på at det er midt på sommeren og lokalet kan bli ganske varmt. <br/><br/>

            Hvis du trenger litt inspirasjon kan du se på denne <span> </span>

            <a
              href="https://pin.it/1phDOSrBC"
              target="_blank"
              rel="noopener noreferrer"
            >
            linken
            </a>
            .
          
          </p>
        </div>
      </Card_left>
    </section>
  );
}
